export default function setIsPinned(state, action) {
  return {
    ...state,
    sidebar: {
      ...state.sidebar,
      isPinned: action.payload,
    },
  };
}
